import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";

const { useBreakpoint } = Grid;

export function FAQSBackground({ banner = {} }) {
	const screens = useBreakpoint();
	return (
		<div style={{ width: "100%", position: "relative" }}>
			<WrapperSection>
				<RAImage
					url={screens.xs ? banner?.mobile_banner : screens.sm ? banner?.desktop_banner : ""}
					width="100%"
					height={screens.xs ? "442px" : "50vh"}
				/>
				<WrapperContent>
					<TextContainer className="animate__animated animate__fadeInUp animate__slow">
						<RATypography
							variant={screens?.md ? "h1" : "h2"}
							color="#fff"
							style={{ display: "inline" }}
							whiteSpace="pre-wrap"
						>
							{banner?.title || ""}
						</RATypography>
					</TextContainer>
				</WrapperContent>
			</WrapperSection>
		</div>
	);
}

const WrapperSection = styled.div`
	width: 100%;
`;
const TextContainer = styled.div`
	text-align: center;
	background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
`;
const WrapperContent = styled.div`
	position: absolute;
	top: 25%;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;
